export const FZSSTORAGE = 'FZSSTORAGE';

